import React, { useContext, useEffect } from 'react'
import {
  ICheckboxFilter,
  IFilter,
  IRadioFilter
} from 'react-angle-dashboard-components'
import { Directory } from '../../components/Directory'
import { filters, getDistanceIndex, getFacilityTypeIndex } from './filters'
import { IDirectoryProps } from 'react-angle-dashboard-components/dist/components/Directory'
import { facilityService } from '../../services'
import { useLocation } from 'react-router-dom'
import { NavbarContext } from '../../components/Navbar/NavbarContext'
import routes from '../../routes/paths'
import { useHistory } from 'react-router-dom'
import { useQuery } from 'react-query'

export const FacilityDirectory: React.FC = () => {
  const { setBackInfo } = useContext(NavbarContext)
  const initialFilters: IFilter[] = filters

  useEffect(() => {
    setBackInfo({
      link: routes.care,
      text: 'Back to Angle'
    })
  }, [setBackInfo])

  const history = useHistory()
  const { googleApiKey } = (window as any).runtimeConfig

  const urlSearchParams = new URLSearchParams(useLocation().search)

  const lat = urlSearchParams.get('lat') || ''
  const lng = urlSearchParams.get('lng') || ''
  const nameFilter = urlSearchParams.get('query') || undefined

  const { data: services, isLoading } = useQuery(['facilitySpecialties'], () =>
    facilityService.getFacilityTypesCheckboxFilter()
  )

  if (services) {
    // The User clicked on a common specialty of type facility in FindCare page
    const isCommonSpecialty = urlSearchParams.get('common')
    const filterValue = urlSearchParams.get('service')
    const distanceValue = urlSearchParams.get('distance')

    const facilityTypeFilterIndex = getFacilityTypeIndex()
    const distanceIndex = getDistanceIndex()

    if (distanceValue) {
      // Make sure to only accept values from the provided options
      const newValue = (
        initialFilters[distanceIndex] as IRadioFilter
      ).options.find((x) => x.value === Number(distanceValue))?.value

      if (newValue) {
        ;(initialFilters[distanceIndex] as IRadioFilter).value =
          Number(newValue)
      }
    }

    const currentFilter = initialFilters[
      facilityTypeFilterIndex
    ] as ICheckboxFilter

    currentFilter.value = services

    if (facilityTypeFilterIndex !== -1 && (nameFilter || filterValue)) {
      currentFilter.value['Urgent Care Clinic'].value = false
    }
    if (filterValue) {
      Object.keys(currentFilter.value).forEach((k) => {
        if (
          isCommonSpecialty &&
          k.toLowerCase().includes(filterValue.toLowerCase())
        ) {
          // Will select all facility services that contain the value of the clicked common specialty in the FindCare page
          currentFilter.value[k].value = true
        } else {
          currentFilter.value[k].value = false
        }
      })

      if (filterValue.includes(',')) {
        filterValue.split(',').forEach((v) => {
          if (currentFilter.value[v]) {
            currentFilter.value[v].value = true
          }
        })
      } else if (currentFilter.value[filterValue]) {
        currentFilter.value[filterValue].value = true
      }
    }
  }

  let center
  if (lat && lng) {
    center = { lat: +lat, lng: +lng }
  }

  const navigateToProfile = (id: number | string) => {
    history.push(`/facilities/${id}`)
  }

  const directoryConfig: IDirectoryProps = {
    initialFilters,
    googleApiKey,
    reactQueryConfig: {
      key: 'facilities',
      asyncSearchFn: facilityService.find.bind(facilityService)
    },
    itemsName: 'Facilities',
    emptySearchText: 'Please alter your search parameters to find facilities.',
    emptySearchTitle: 'No results found.',
    markerIcon: 'icon-facility',
    cardClickHandler: navigateToProfile,
    isProvider: false,
    initialCenter: center,
    initialNameFilter: nameFilter,
    navbarHeight: 145
  }

  return isLoading ? null : <Directory {...directoryConfig} />
}

export default FacilityDirectory
